import type { AddressOrNative, ExplicitAddress } from '@cronos-app/sdk';
import { useQuery } from '@tanstack/react-query';
import { RefetchInterval } from '@ui/config/ui';
import { useSDK } from '@ui/utils';

export const useH2SwapGasFee = (
  inputTokenAddress: AddressOrNative,
  outputTokenAddress: ExplicitAddress,
) => {
  const sdk = useSDK();

  return useQuery({
    queryKey: ['useH2SwapGasFee', sdk, inputTokenAddress, outputTokenAddress],
    queryFn: async () => {
      return sdk
        .getGasFeeEstimator()
        .estimateGasForSwap(inputTokenAddress, outputTokenAddress);
    },
    refetchInterval: RefetchInterval.Normal,
    enabled: !!sdk,
  });
};
